"use client";

import { useActionState, useEffect, useState } from "react";
import { handleLogin } from "./handle-login";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2Icon } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import Link from "next/link";

export default function LoginPage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [state, formAction, pending] = useActionState(handleLogin, null);
  const rollNumber = searchParams?.get("roll_no");

  const [year, setYear] = useState<number>(new Date().getFullYear());

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  useEffect(() => {
    if (state?.success) {
      sessionStorage.setItem("vmcnat", JSON.stringify(state.data));

      router.push(state.redirectTo);
    }
  }, [state, router]);

  return (
    <div className="relative w-full h-screen">
      <div className="sticky top-0 z-50 w-full bg-[var(--vmc-bg)]">
        <div
          className="ticker  bg-gradient-to-r from-[var(--vmc-gold)] to-[var(--vmc-gold-2)] text-[var(--vmc-deep)] shadow"
        // style={{ display: "none" }}
        >
          <div className="relative overflow-hidden">
            <p className="ticker-move whitespace-nowrap py-2.5 px-6 font-semibold tracking-tight">
              Vidyamandir Intellect Quest (VIQ2026) Result  is declared. Please login below to check your Result Analysis and Result Letter.
            </p>
          </div>
        </div>

        {/* VMC Logo */}
        <Link
          href="#"
          className="mb-6 p-5 md:right-5 md:top-5 md:mb-0 flex justify-center md:justify-end"
          aria-label="Vidya Mandir Home"
        >
          <img
            src="https://scholarshiptest.vidyamandir.com/_next/image?url=%2Fvmc.png&w=256&q=75"
            alt="Vidya Mandir Classes logo"
            className="h-15 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>

      {/* Login Form */}
      {/* <div className="relative z-10 flex flex-col items-center justify-center h-screen bg-white/50">
        <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-8">
          <div className="flex justify-center mb-6">
            <Image
              src="/vmc.png"
              alt="VMC Logo"
              width={150}
              height={50}
              className="object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-center mb-4">
            Login to Your Account
          </h1>
          <p className="text-sm text-gray-600 text-center mb-6">
            Enter your Registration No. and date of birth to access your profile
            or admit card.
          </p>
          <form id="login-form" action={formAction} className="space-y-6">
            <div>
              <Label
                htmlFor="rollNo"
                className="block text-sm font-medium text-gray-700"
              >
                Registration No.
              </Label>
              <Input
                id="rollNo"
                name="rollNo"
                placeholder="Enter Registration No."
                defaultValue={rollNumber || ""}
                className="mt-1 block w-full"
                required
              />
            </div>
            <div>
              <Label
                htmlFor="dob"
                className="block text-sm font-medium text-gray-700"
              >
                Date of Birth
              </Label>

              <Input
                id="dob"
                name="dob"
                type="date"
                placeholder="Select DOB"
                className="mt-1 block w-full input-group input-medium date date-picker"
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full py-2 text-lg font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              disabled={pending}
            >
              {pending ? <Loader2Icon className="animate-spin" /> : "Login"}
            </Button>
            {state && !state.success && (
              <p className="text-sm text-red-500 text-center mt-2">
                {state.error}
              </p>
            )}
          </form>
        </div>
      </div> */}

      <div className="min-h-[calc(100vh-88px)] flex items-center justify-center p-4">
        <div className="w-full max-w-6xl bg-white/80 rounded-2xl shadow-xl overflow-hidden grid md:grid-cols-2">
          {/* Left: Welcome / Gradient hero */}
          <section className="relative p-10 md:p-12 lg:p-16 bg-gradient-to-br from-[var(--vmc-navy)] via-[var(--vmc-navy-2)] to-[var(--vmc-deep)] text-white">
            <div
              className="absolute inset-0 pointer-events-none opacity-10"
              style={{
                backgroundImage:
                  "radial-gradient(#ffffff 1px, transparent 1px)",
                backgroundSize: "16px 16px",
              }}
            ></div>
            <div className="absolute -left-12 bottom-10 w-64 h-64 rounded-3xl bg-[var(--vmc-gold)]/30 blur-2xl"></div>
            <div className="absolute right-10 top-10 w-40 h-40 rounded-full bg-[var(--vmc-gold)]/20 blur-xl"></div>
            {/* <div className="absolute left-10 bottom-24 w-24 h-10 rounded-full rotate-12 bg-[var(--vmc-gold)]/70"></div>
            <div className="absolute left-36 bottom-14 w-20 h-9 rounded-full -rotate-12 bg-[var(--vmc-gold-2)]/80"></div> */}
            <div className="absolute right-5 bottom-8 w-16 h-7 rounded-full rotate-6 bg-white/40"></div>

            <div className="relative">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
                Scholarship Test Portal login
              </h1>
              <p className="mt-5 text-white/90 max-w-xl mb-3">
                You can login to the Scholarship portal for the following
              </p>

              <ol className="pl-1 space-y-4 text-white">
                <li className="relative pl-[2.3rem]">
                  <img
                    src="https://vidyamandir.com/assets/images/arrow-icon.png"
                    className="h-7 absolute left-0"
                    alt="arrow-icon"
                  />
                  If you have registered for the Scholarship test, then you can
                  login to fill additional information and download your Admit
                  card.
                </li>
                <li className="relative pl-[2.3rem]">
                  <img
                    src="https://vidyamandir.com/assets/images/arrow-icon.png"
                    className="h-7 absolute left-0"
                    alt="arrow-icon"
                  />
                  If you have registered for the Scholarship test, then you can
                  login to change your information or details.
                </li>
                <li className="relative pl-[2.3rem]">
                  <img
                    src="https://vidyamandir.com/assets/images/arrow-icon.png"
                    className="h-7 absolute left-0"
                    alt="arrow-icon"
                  />
                  If you have taken the Scholarship test, then you can login to
                  check your Result letter and detailed Result analytics.
                </li>
              </ol>
            </div>
          </section>

          {/* Right: Login form */}
          <section className="relative bg-white p-8 sm:p-10 lg:p-12 flex flex-col items-center">
            {/* Login Form */}
            <form
              id="login-form"
              className="w-full"
              action={formAction}
              aria-labelledby="loginTitle"
            >
              <div className="mb-8">
                <h2
                  id="loginTitle"
                  className="text-center md:text-left text-xl sm:text-2xl font-bold text-[var(--vmc-navy)] tracking-tight"
                >
                  Student Login
                </h2>
              </div>

              {/* Registration Number */}
              <Label className="block">
                <span className="sr-only">Registration Number</span>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-[var(--vmc-navy-2)]/70"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <path
                        d="M20 21a8 8 0 10-16 0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </span>
                  <input
                    id="rollNo"
                    name="rollNo"
                    placeholder="Roll Number"
                    className="w-full pl-12 pr-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[var(--vmc-gold)] test-ba
                    test-[16px] focus:border-transparent placeholder-slate-400 text-base"
                    defaultValue={rollNumber || ""}
                    required
                  />
                </div>
              </Label>

              {/* Date of Birth */}
              <Label className="block mt-4">
                <span className="sr-only">Date of Birth</span>
                {/* <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-[var(--vmc-navy-2)]/70"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <rect x="4" y="11" width="16" height="9" rx="2" />
                      <path d="M8 11V7a4 4 0 118 0v4" />
                    </svg>
                  </span>
                  <input
                    id="dob"
                    name="dob"
                    type="date"
                    className="w-full min-w-0 appearance-none pl-12 pr-6 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[var(--vmc-gold)] focus:border-transparent placeholder-slate-400 text-base"
                    placeholder=""
                    required
                  />
                </div> */}
                <div className="relative pl-12 pr-6 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[var(--vmc-gold)] focus:border-transparent placeholder-slate-400">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 text-[var(--vmc-navy-2)]/70"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <rect x="4" y="11" width="16" height="9" rx="2" />
                      <path d="M8 11V7a4 4 0 118 0v4" />
                    </svg>
                  </span>
                  <input
                    id="dob"
                    name="dob"
                    type="date"
                    className="w-full border-0 focus:outline-none focus:ring-2 focus:ring-[var(--vmc-gold)] focus:border-transparent"
                    placeholder=""
                    required
                    autoComplete="current-password"
                  />
                </div>
              </Label>

              {/* Submit */}
              <button
                type="submit"
                className="mt-6 w-full py-3.5 rounded-xl font-semibold tracking-wide text-[var(--vmc-deep)] bg-gradient-to-r from-[var(--vmc-gold)] to-[var(--vmc-gold-2)] hover:opacity-95 focus:outline-none focus:ring-4 focus:ring-[var(--vmc-gold)]/40 transition text-base flex justify-center"
                disabled={pending}
              >
                {pending ? <Loader2Icon className="animate-spin" /> : "Login"}
              </button>

              {state && !state.success && (
                <p className="text-sm text-red-500 text-center mt-2">
                  {state.error}
                </p>
              )}

              {/* Footer */}
              <p className="mt-8 text-center text-xs text-slate-400">
                © {year} Vidyamandir. All rights reserved.
              </p>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}
